export const leagueWinnersOdds = {
	4: { // Euro
		2024: '9.00',
		2020: '10.00',
		2016: '21.00'
	},
	2: {
		2023: '9.00',
		2022: '3.50',
		2021: '15.00',
		2020: '30.00',
		2019: '13.00',
		2018: '12.00',
		2017: '5.00',
		2016: '6.00',
		2015: '6.50',
		2014: '6.00'
	},
	253: {
		2024: '9.00'
	},
}